import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ProjectsSlider {
    constructor() {
        this.slider = document.querySelector('.projectsSwiper');
        if (!this.slider) return;

        this.progressIndicator = document.querySelector('.projects .projects__progressIndicator');
        this.slides = this.slider.querySelectorAll('.projects__slideContent > .cardProject');

        this.init();
    }

    init() {
        this.initSwiper();
        this.animateOnScroll();

        // Animation initiale de la première slide
        this.animateSlideContent(this.swiper.slides[this.swiper.activeIndex]);
    }

    // ---------- SWIPER ----------
    initSwiper() {
        this.swiper = new Swiper(this.slider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 200,
            speed: 800,
            autoHeight: true,
            watchOverflow: false,
            navigation: {
                nextEl: '.projects__navBtn--next',
                prevEl: '.projects__navBtn--prev',
            },
            on: {
                slideChange: (swiper) => this.updateProgress(swiper),
                init: (swiper) => this.updateProgress(swiper),
                slideChangeTransitionStart: (swiper) => this.onSlideChange(swiper),
            },
        });
    }

    updateProgress(swiper) {
        const totalSlides = swiper.slides.length;
        const indicatorWidth = 100 / totalSlides;
        const position = (swiper.activeIndex / (totalSlides - 1)) * (100 - indicatorWidth);

        this.progressIndicator.style.width = `${indicatorWidth}%`;
        this.progressIndicator.style.left = `${position}%`;
    }

    destroy() {
        if (this.swiper) this.swiper.destroy();
    }

    // ---------- ANIMATIONS AU SCROLL ----------
    animateOnScroll() {
        this.slides.forEach((slide) => {
            gsap.from(slide, {
                y: 100,
                opacity: 0,
                duration: 1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: slide,
                    scrub: true,
                    start: 'top 95%',
                    end: 'bottom 60%',
                    toggleActions: 'play none none reverse',
                },
            });
        });
    }

    // ---------- ANIMATIONS AU CHANGEMENT DE SLIDE ----------
    onSlideChange(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        this.animateSlideContent(activeSlide);
    }

    animateSlideContent(slide) {
        if (!slide) return;

        const contentElements = slide.querySelectorAll('.cardProject__title, .cardProject__group');

        gsap.fromTo(
            contentElements,
            { x: 30, opacity: 0, delay: .2 },
            { x: 0, opacity: 1, duration: 1, ease: 'power2.out', stagger: 0.2 }
        );
    }
}
